export default {
    empty: 'The list is empty',
    participantsCount: '{{count}} pt.',
    lackOfRights: 'Insufficient rights to manage\nthe list. Please contact your\nsupervisor to obtain rights.',
    selectedFirmAlreadyAdded: 'The selected company is\nalready on this list',
    selectedFirmsAlreadyAdded: 'All selected companies\nare already on this list',
    scrollAddedFirms: '{{count}} {{firmPlural}} already on the list.',
    willAddFirms: 'We will add {{count}} {{firmPlural}}'
};
